import {useCheckoutStore} from "~/store/checkout";
import {PublicConfig} from "~/utils/types/config";

export default defineNuxtRouteMiddleware(async (to, from) => {
    if (to.name !== undefined) return

    try {
        const config: PublicConfig = useRuntimeConfig().public as PublicConfig;

        const data: any = await $fetch(`/checkout${to.path}`, {
            baseURL: config.api_url,
            method: 'GET'
        })

        const eventData: EventData = data?.data.event

        const userLang = data?.data.user.language

        if (userLang) return navigateTo(`/${userLang}${to.fullPath}`, { replace: true })

        if (!eventData.language) return

        eventData.language = eventData.language === 'pt_PT' ? 'pt' : eventData.language

        return navigateTo(`/${eventData.language}${to.fullPath}`, { replace: true })
    } catch (err) {
        return
    }
})
